"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ajax_util_1 = require("../ajax/ajax.util");
var constants_1 = require("../../constants");
var REQUEST_URI = constants_1.default.REQUEST_URI;
// max number of errors logged per session
var MAX_ERRORS = 2;
// error count
var errors = 0;
/**
 * post the messages to the server
 */
function log(store, url, message, file, line, column, error) {
    if (message === void 0) { message = ""; }
    if (file === void 0) { file = ""; }
    var state = store.getState(), _csrf = state._csrf, history = (state.route && state.route.history) || "", isCspError = message && message.includes("SecurityError"), errorOriginFile = getErrorOrigin(file), shouldThrowError = errorOriginFile !== "3rdParty" && !isCspError, 
    // Cross-origin policy errors in 3rd party code, from which the browser strips any useful info
    is3rdPartyScriptError = message && message.includes("Script error."), failedLoadingScriptError = message && message.includes("fail to load script");
    function responseHandler(data) {
        return;
    }
    if (!is3rdPartyScriptError &&
        !shouldThrowError &&
        !failedLoadingScriptError) {
        ajax_util_1.default.post$(store.dispatch, _csrf, url, {
            message: "PROFILE::CLIENT_UNCAUGHT_ERROR:" + message,
            href: window.location.href,
            file: file,
            line: line,
            column: column,
            stack: error ? error.stack : "",
            userAgent: navigator.userAgent,
            history: history,
        })
            .then(responseHandler)
            .catch(function (err) { return responseHandler(err.response); });
    }
    return false;
}
/**
 * start capturing global errors
 * @param store
 * @param url where we POST the errors
 */
function start(store, url) {
    window.onerror = function (message, file, line, column, error) {
        // avoid spamming the service if there are a lot of errors
        if (errors > MAX_ERRORS) {
            return;
        }
        errors++;
        // log the messages to the server
        log(store, url, message, file, line, column, error);
    };
}
/**
 * @function getErrorOrigin - determines if error originated from our app bundles; if so, assign filename to variable
 * @param file - file name from error object
 */
function getErrorOrigin(file) {
    if (file === void 0) { file = ""; }
    switch (true) {
        case file.includes("/appBundle.js"):
            return "appBundle";
        case file.includes("/vendor.js"):
            return "vendor";
        default:
            return "3rdParty";
    }
}
exports.default = {
    start: start,
    log: log,
};
